import { useEffect, useState } from 'react';
import customAxios from 'routes/Pages/util/Api';
import authHeader from 'services/auth/jwt/auth-header';

const useGetLengthChecker = () => {
  const [lengthCheckerData, setLengthCheckerData] = useState([]);

  useEffect(() => {
    getLengthCheckerData();
  }, []);

  const getLengthCheckerData = async () => {
    try {
      const response = await customAxios.get('/Ops/GetLen', {
        headers: authHeader(),
      });

      if (response.status === 200) {
        const sorted = [...(response?.data || [])].sort((a, b) => b.lengthID - a.lengthID);
        setLengthCheckerData(sorted);
      }
    } catch (error) {
      console.log(error);
    }
  };

  return {
    lengthCheckerData,
  };
};

export default useGetLengthChecker;
